import { render, staticRenderFns } from "./customer_analysis.vue?vue&type=template&id=c127a3f4&scoped=true&"
import script from "./customer_analysis.vue?vue&type=script&lang=js&"
export * from "./customer_analysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c127a3f4",
  null
  
)

export default component.exports